import { Mail, AlertCircle } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { FadeUp, Eyebrow } from "@/components/Reveal";
import { EMAILS } from "@/config";

const STEPS = [
  "Five Star uygulamasını aç.",
  "Ayarlar bölümüne gir.",
  "“Hesabımı Sil” seçeneğini seç.",
  "Ekrandaki onayı tamamla.",
];

export default function AccountDeletionPage() {
  return (
    <>
      <PageHeader silk={2}
        testid="account-deletion-header"
        eyebrow="Hesap Silme"
        titleLines={["Hesabını", "silme."]}
        lede="Five Star hesabını dilediğin zaman uygulama içinden silebilirsin. Hesap silme işlemi, uygulamanın silme sürecine göre Five Star hesabını kalıcı olarak kaldırır."
      />
      <section className="bg-ivory pb-24 sm:pb-32 px-6">
        <div className="max-w-5xl mx-auto">
          <FadeUp>
            <Eyebrow>Adımlar</Eyebrow>
          </FadeUp>
          <div className="mt-8">
            {STEPS.map((s, i) => (
              <FadeUp key={i} delay={i * 0.08}>
                <div data-testid={`deletion-step-${i + 1}`} className="flex items-baseline gap-6 sm:gap-8 border-t border-burgundy/10 py-7">
                  <span className="font-cinzel text-2xl text-gold w-10 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <p className="font-serif text-xl sm:text-2xl text-ink">{s}</p>
                </div>
              </FadeUp>
            ))}
            <div className="border-t border-burgundy/10" />
          </div>

          <FadeUp delay={0.2} className="mt-12">
            <div
              data-testid="deletion-subscription-note"
              className="bg-white/90 border-l-2 border-gold rounded-[4px] p-7 sm:p-8 flex gap-5"
            >
              <AlertCircle className="w-5 h-5 text-gold shrink-0 mt-0.5" aria-hidden="true" />
              <div>
                <h2 className="font-serif text-xl text-ink">App Store aboneliğin hakkında</h2>
                <p className="mt-2.5 text-[15px] font-light text-ink-soft/90 leading-relaxed">
                  Five Star hesabını silmek, App Store aboneliğini otomatik olarak iptal etmeyebilir. Aktif aboneliğini
                  Apple ID &rarr; Abonelikler bölümünden yönetebilirsin.
                </p>
              </div>
            </div>
          </FadeUp>

          <FadeUp delay={0.3} className="mt-12 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
            <p className="text-sm text-ink-muted">Hesap silme konusunda desteğe mi ihtiyacın var?</p>
            <a
              href={`mailto:${EMAILS.support}?subject=${encodeURIComponent("Hesap Silme")}`}
              data-testid="deletion-support-mailto"
              className="inline-flex items-center gap-2.5 px-6 py-3 rounded-[3px] text-sm font-sans font-medium tracking-wide bg-burgundy text-ivory-light border border-burgundy hover:bg-burgundy-hover transition-all duration-300 self-start"
            >
              <Mail className="w-4 h-4" aria-hidden="true" />
              {EMAILS.support}
            </a>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
